
// Generar número de tarjeta aleatorio
export function generateCardNumber(): string {
  const prefix = '4532'; // Visa prefix
  let number = prefix;
  
  for (let i = 0; i < 12; i++) {
    number += Math.floor(Math.random() * 10);
  }
  
  // Formatear con espacios
  return number.replace(/(.{4})/g, '$1 ').trim();
}

// Generar CVV aleatorio
export function generateCVV(): string {
  return Math.floor(Math.random() * 900 + 100).toString();
}

// Generar fecha de expiración (2 años en el futuro)
export function generateExpiryDate(): string {
  const now = new Date();
  const futureYear = now.getFullYear() + 2;
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const year = String(futureYear).slice(-2);
  
  return `${month}/${year}`;
}

// Formatear moneda en pesos dominicanos
export function formatCurrency(amount: number): string {
  return `RD$ ${amount.toLocaleString('es-DO', { 
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 
  })}`;
}

// Enmascarar número de tarjeta
export function maskCardNumber(cardNumber: string): string {
  const cleaned = cardNumber.replace(/\s/g, '');
  const masked = '**** **** **** ' + cleaned.slice(-4);
  return masked;
}

// Validar número de tarjeta (algoritmo de Luhn simplificado)
export function validateCardNumber(cardNumber: string): boolean {
  const cleaned = cardNumber.replace(/\s/g, '');
  return cleaned.length >= 13 && cleaned.length <= 19 && /^\d+$/.test(cleaned);
}

// Validar CVV
export function validateCVV(cvv: string): boolean {
  return /^\d{3,4}$/.test(cvv);
}

// Validar fecha de expiración
export function validateExpiryDate(expiryDate: string): boolean {
  const regex = /^(0[1-9]|1[0-2])\/\d{2}$/;
  if (!regex.test(expiryDate)) return false;
  
  const [month, year] = expiryDate.split('/');
  const expiry = new Date(2000 + parseInt(year), parseInt(month) - 1);
  const now = new Date();
  
  return expiry > now;
}

// Validar cédula dominicana (11 dígitos)
export function validateCedula(cedula: string): boolean {
  const cleaned = cedula.replace(/\D/g, '');
  return cleaned.length === 11 && /^\d+$/.test(cleaned);
}

// Formatear cédula dominicana (000-0000000-0)
export function formatCedula(cedula: string): string {
  const cleaned = cedula.replace(/\D/g, '');
  if (cleaned.length === 0) return '';
  if (cleaned.length <= 3) return cleaned;
  if (cleaned.length <= 10) return `${cleaned.slice(0, 3)}-${cleaned.slice(3)}`;
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 10)}-${cleaned.slice(10, 11)}`;
}
